<template>
    <div v-if="infoData" :style="infoData.layout">
        <div v-if="infoData.cont.titname!=''" :style="infoData.cont.titnamelayout">
           {{infoData.cont.titname}}
        </div>
        <div v-if="infoData.cont.titsm!=''" :style="infoData.cont.titsmlayout" v-html="infoData.cont.titsm">
            {{infoData.cont.titsm}}
        </div>
        <div v-if="infoData.cont.imgurl!=''" :style="infoData.cont.imglayout" style="position: relative;">
            <a @click="goto(infoData.cont)" style="cursor: pointer; width: 100%;height: 100%;position: absolute;top:0;left: 0; display: block;"></a>

            <div style="width: 100%;height: 100%;background-repeat: no-repeat; background-position: center center;"
                 :style="{ backgroundImage: 'url(' + infoData.cont.imgurl + ')' }"
            >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "infoboxC",
        props:{
            infoData:{},
        },
        data(){
            return{
               // tt:'../../../static/tt5.png',
            }

        },
        methods:{
            goto(it){
                console.log(it);
                if(it.type==undefined){return false}

                if(it.type=='link'){
                    window.open(it.url, it.target);
                }
                if(it.type=='rout'){
                    //this.$router.push({'path': it.url, query: {'id': it.valval}});
                    var url='';
                    if(it.valval!='') {
                        url = this.$router.resolve({path: it.url, query: {'id': it.valval}}).href;
                    }
                    if(it.valval==''){
                        url = this.$router.resolve({path: it.url}).href;
                    }
                    if(url!='') {
                        window.open(url, it.target);
                    }

                }


            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/comp/infoboxC.vue